import { DONATION_INFO_TEXT } from './../donation-info';
import { DOCUMENT } from '@angular/common';
import { EventsService } from './../../../../shared/services/events/events.service';
import { Component, OnInit, Inject } from '@angular/core';
import { VariablesService, UtilService, VwoService } from '../../../../shared/services';
import { ICampaigner } from '../../../../fundraiser/models/fundraiser.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-donation-confirmation',
  templateUrl: './donation-confirmation.component.html',
  styleUrls: ['./donation-confirmation.component.scss']
})
export class DonationConfirmationComponent implements OnInit {

  beneficiaryName;
  isNGO = false;
  isStorypage = false;
  miniStory = false;
  campaigner: ICampaigner;
  isMedical = false;

  cancelPayment = new Subject();
  constructor(
    public vars: VariablesService,
    public util: UtilService,
    public vwo: VwoService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DonationConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private events: EventsService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private actRoute: ActivatedRoute
  ) { }

  info = DONATION_INFO_TEXT;

  ngOnInit() {
    this.getBeneficiaryName();
    if (this.router.url.match('stories')) {
      this.isStorypage = true;
    }
    if (this.actRoute.snapshot.queryParams.mini_story) {
      this.miniStory = true;
    }
  }

  getBeneficiaryName() {
    if (this.vars.fundraiser && this.vars.fundraiser.beneficiary) {
      this.beneficiaryName = this.vars?.fundraiser?.beneficiary?.full_name || this.vars?.basicInfo?.beneficiary_name;
    } else if (this.vars?.fundraiser?.beneficiaryname) {
      this.beneficiaryName = this.vars?.fundraiser?.beneficiaryname?.info_1;
    } else {
      this.beneficiaryName = this.vars?.basicInfo?.beneficiary_name;
    }
    this.isNGO = this.vars.fundraiser?.parent_cause_id === 48;
    this.isMedical = this.vars.ALL_MEDICAL_CAUSES.includes(this.vars.fundraiser?.cause?.id) ? true : false;
  }

  handleCloseAndSendEvent(choice): void {
    const self = this;
    const choices = {
      cancel: () => {
        self.dialog.closeAll();
        this.cancelPayment.next(true);
        return 'cancel_popup';
      },
      closeBtn: () => {
        self.dialogRef.close();
        return 'close_btn_popup';
      },
      help: () => {
        self.dialogRef.close();
        return 'help_popup';
      }
    };

    const info1 = choices[choice]() || '';
    const payload = {
      eventName: 'donation_confirmation',
      event_type: 'campaign',
      page_name: this.vars.pageName || 'home',
      referrer_page: this.document.referrer,
      event_type_id: this.vars.fundraiser.id,
      info_1: info1,
      info_2: ''
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }

}
